import React, { useState, useEffect } from 'react';
import generateLocalTimingObj from './timeZoneConversionsMethods';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  border: {
    border: '2px solid red',
  },
});
const ShowTimings = ({ state, title, slotsDay }) => {
  const currentDayTime = state[title.toLowerCase()];
  const sortedTimings = currentDayTime.sort();
  const classes = useStyles();
  if (state[title.toLowerCase()].length === 0) {
    return (
      <p
        className={`small`}
        style={{
          background:
            new Date().toString().split(' ')[0] === title
              ? 'rgba(0, 0, 0, 0.1)'
              : 'white',
          padding: '0 4px',
        }}
      >
        {title} &nbsp; closed
      </p>
    );
  }

  return (
    <p
      className={`px-1 small ${
        slotsDay === title.toLowerCase() && `${classes.border}`
      }`}
      style={{
        background:
          new Date().toString().split(' ')[0] === title
            ? 'rgba(0, 0, 0, 0.1)'
            : 'white',
        padding: '0 4px',
      }}
    >
      {title} &nbsp;
      {sortedTimings.map((data, i) => (
        <>
          {data.map((dta, index) => (
            <>
              {dta} &nbsp; {index === 0 && '-'}{' '}
            </>
          ))}
          &nbsp; {i < sortedTimings.length - 1 && '&'} &nbsp;
        </>
      ))}
    </p>
  );
};

// main component for timezone conversions
const TimeZoneConversions = ({ timings, days, zone }) => {
  const [timeObjState, setTimeObjState] = useState({
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: [],
  });
  const [slotsDay, setSlotsDay] = useState(
    Date().toString().split(' ')[0].toLowerCase()
  );

  // when converting timezones the date can change e.g, sunday in the IST can change to mon or saturday , these need to ordered correctly.
  const generateLocalTimingArrayObj = () => {
    const timeObj = generateLocalTimingObj(days, timings, zone);
    setTimeObjState(timeObj);

    const todayDate = new Date();
    const todayDay = todayDate.toString().split(' ')[0].toLowerCase();

    // countdown
    let day = todayDay;
    let dayIndex = days.indexOf(todayDay);

    // if the timings of today is empty then to check how many days it goes ahead
    let count = 0;

    // this is used to give the boxes on the particular/upcoming timezone
    const checkSlots = () => {
      if (timeObj[days[dayIndex]].length === 0) {
        dayIndex = dayIndex === 6 ? 0 : dayIndex + 1;
        day = days[dayIndex];
        count++;
        console.log('day1', day);
      } else {
        if (todayDay === day) {
          // getting countdown for next time/day timings and sorting them
          const dayConvertedTimings = timeObj[days[dayIndex]];
          const sortedDayConvertedTimings = dayConvertedTimings.sort();

          const getCurrentHours = new Date().getHours();

          // counting diff of current hour with timings and store in positive and negative diff array
          let positiveDiff = [];
          let negativeDiff = [];
          sortedDayConvertedTimings.forEach((time, index) => {
            if (getCurrentHours - parseInt(time[0].slice(0, 2)) < 0) {
              negativeDiff.push({
                index,
                day,
                timeDiff: getCurrentHours - parseInt(time[0].slice(0, 2)),
              });
            } else {
              positiveDiff.push({
                index,
                day,
                timeDiff: getCurrentHours - parseInt(time[0].slice(0, 2)),
              });
            }
            if (negativeDiff.length === 0) {
              let newDayIndex = dayIndex === 6 ? 0 : dayIndex + 1;
              let newDay = days[newDayIndex];

              for (let i = newDayIndex; i < 7; i++) {
                if (timeObj[days[i]].length === 0) {
                  newDayIndex = newDayIndex === 6 ? 0 : newDayIndex + 1;
                  newDay = days[newDayIndex];
                } else {
                  // newDayIndex = newDayIndex === 6 ? 0 : newDayIndex + 1;
                  // newDay = days[newDayIndex];
                  break;
                }
              }

              if (timeObj[newDay].length === 0) {
                for (let i = 0; i < dayIndex; i++) {
                  if (timeObj[days[i]].length === 0) {
                    newDayIndex = newDayIndex === 6 ? 0 : newDayIndex + 1;
                    newDay = days[newDayIndex];
                  } else {
                    // newDayIndex = newDayIndex === 6 ? 0 : newDayIndex + 1;
                    // newDay = days[newDayIndex];
                    break;
                  }
                }
              }
              setSlotsDay(newDay);
            } else {
              setSlotsDay(todayDay);
            }
          });
        } else {
          setSlotsDay(day);
        }
      }
    };
    setInterval(() => checkSlots(), 1000);
  };

  useEffect(() => {
    generateLocalTimingArrayObj();
  }, []);

  return (
    <>
      {/* monday  */}
      <ShowTimings title="Mon" state={timeObjState} slotsDay={slotsDay} />

      {/* tuesday  */}
      <ShowTimings title="Tue" state={timeObjState} slotsDay={slotsDay} />

      {/* wednesday  */}
      <ShowTimings title="Wed" state={timeObjState} slotsDay={slotsDay} />

      {/* thursday  */}
      <ShowTimings title="Thu" state={timeObjState} slotsDay={slotsDay} />

      {/* friday  */}
      <ShowTimings title="Fri" state={timeObjState} slotsDay={slotsDay} />

      {/* saturday  */}
      <ShowTimings title="Sat" state={timeObjState} slotsDay={slotsDay} />

      {/* sunday  */}
      <ShowTimings title="Sun" state={timeObjState} slotsDay={slotsDay} />
    </>
  );
};

export default TimeZoneConversions;
